
document.addEventListener("DOMContentLoaded", (event) => {
    initLocalVideo();
    initSlickCarousel();
    initYouTubeVideo();
});

function initLocalVideo() {
    const videoSections = document.getElementsByClassName('video-hero');
    for (const videoSection of videoSections) {
        let video = videoSection.getElementsByClassName('hero-video')[0];
        let toggleBtn = document.getElementById(video.dataset.videoToggleId);
        toggleBtn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                videoToggleDisplay(toggleBtn, false);
            } else {
                video.pause();
                videoToggleDisplay(toggleBtn, true);
            }
        });
    }
}

function videoToggleDisplay(toggleBtn, status) {
    let pauseBtn = toggleBtn.getElementsByClassName('pause')[0];
    let playBtn = toggleBtn.getElementsByClassName('play')[0];
    if (status) {
        pauseBtn.classList.add('d-none');
        playBtn.classList.remove('d-none');
        toggleBtn.setAttribute('aria-label', 'Play video');
        toggleBtn.setAttribute('aria-pressed', 'false');
    }
    else {
        playBtn.classList.add('d-none');
        pauseBtn.classList.remove('d-none');
        toggleBtn.setAttribute('aria-label', 'Pause video');
        toggleBtn.setAttribute('aria-pressed', 'true');
    }
}

function initYouTubeVideo() {
    let videos = jQuery('.video-grid .video-container');
    if (videos.length > 0) {
        videos.each(function (index, video) {
            let $holder = jQuery(this);
            let $button = $holder.find('button');
            let modal = $button.data('bs-target');
            let iframeId = '#' + $button.data('iframe');
            let modalEl = jQuery(modal);

            modalEl.on('show.bs.modal', event => {
                jQuery(iframeId).attr('src', jQuery(iframeId).data('original-src'));
            });
            modalEl.on('hidden.bs.modal', event => {
                jQuery(iframeId).attr('src', '');
            });
        });
    }
}

//slick init
function initSlickCarousel() {
    jQuery('.fade-in-slider-images-container').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: false,
        centerMode: true,
        mobileFirst: true,
        centerPadding: '0',
        asNavFor: '.fade-in-slider-content-container',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '50px',
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                }
            }
        ]
    });
    jQuery('.fade-in-slider-content-container').on('init', function(event, slick) {
        jQuery('.slick-track', jQuery(this)).addClass('h-100');
    });
    jQuery('.fade-in-slider-content-container').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        fade: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: false,
        centerMode: false,
        appendArrows: '.arrows',
        asNavFor: '.fade-in-slider-images-container',
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
    });
    jQuery('.events-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '0',
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
        responsive: [
        {
            breakpoint: 768,
            settings: "unslick"
        }
    ]
    });
    jQuery('.testimonial-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '0',
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });
    let $pdfSlider = jQuery('.pdf-slider');
    $pdfSlider.slick({
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        swipe: true,
        infinite: true,
        adaptiveHeight: false,
        centerMode: true,
        centerPadding: '0',
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev d-block"><i class="fa-solid fa-angle-left"></i><span class="accessibility">Previous Slide</span></button>',
        nextArrow: '<button type="button" class="slick-next d-block"><i class="fa-solid fa-angle-right"></i><span class="accessibility">Next Slide</span></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

    const navSliders = [];
    const imageSliders = [];
    let myModalEl = null;
    const bedImagesNavs = document.getElementsByClassName('bed-images-nav');
    const bedImagesSliders = document.getElementsByClassName('bed-images-slider');
    for (let i = 0; i < bedImagesNavs.length; i++) {
        navSliders.push(jQuery('#' + bedImagesNavs[i].id));
        imageSliders.push(jQuery('#' + bedImagesSliders[i].id));
        navSliders[i].on('init', function(event, slick) {
            let $holder = jQuery(this);
            jQuery('.slide', $holder).on('click', function(event) {
                let $slide = jQuery(this);
                imageSliders[i].slick('slickGoTo', $slide.data('slick-index2'));
            });
        });
        imageSliders[i].slick({
            slidesToScroll: 1,
            rows: 0,
            arrows: false,
            fade: false,
            dots: true,
            slidesToShow: 1,
            swipe: true,
            infinite: true,
            adaptiveHeight: false,
            mobileFirst: true,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        asNavFor: navSliders[i],
                    }
                },
            ]
        });
        navSliders[i].slick({
            slidesToScroll: 1,
            rows: 0,
            arrows: false,
            dots: false,
            slidesToShow: 5,
            swipe: true,
            infinite: true,
            adaptiveHeight: false,
            centerMode: false,
            mobileFirst: false,
            vertical: true,
            asNavFor: imageSliders[i],
            verticalSwiping: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: "unslick",
                },
            ]
        });
        let tmpId = bedImagesNavs[i].id.replace('bed-images-nav-', '');
        myModalEl = document.getElementById("modal-" + tmpId);
        myModalEl.addEventListener('shown.bs.modal', event => {
            jQuery('#bed-images-slider-' + tmpId).slick('slickGoTo', 0);
            if (jQuery(window).width() > 768) {
                jQuery('#bed-images-slider-' + tmpId).slick('unslick').slick('reinit');
                jQuery('#bed-images-nav-' + tmpId).slick('unslick').slick('reinit');
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const animation = document.getElementById('animation-file');
    const mobileAnimation = document.getElementById('mobile-animation-file');

    let $bedsToggle = jQuery('#beds-toggle');
    jQuery($bedsToggle).on('mouseover', function(event) {
        if (window.innerWidth >= 768) {
            jQuery('.dropdown-menu', $bedsToggle).addClass('show');
        }
    });
    let $searchToggle = jQuery('#header-search-toggle');
    jQuery($searchToggle).on('click', function(event) {
        if (window.innerWidth >= 768) {
            jQuery($searchToggle).toggleClass('show');
            jQuery('.header-search-container .header-search-form').toggleClass('show');
        }
        else {
            jQuery('.header-search-container .header-search-form button').toggleClass('focus');
        }
    });
    let $searchField = jQuery('.header-search-container .header-search-form .search-input');
    jQuery($searchField).on('focus', function(event) {
        if (window.innerWidth < 768) {
            jQuery('.header-search-container .header-search-form button').addClass('focus');
        }
        else {
            jQuery('.header-search-container .header-search-form button').removeClass('focus');
        }
    });
    jQuery($searchField).on('focusout', function(event) {
        jQuery('.header-search-container .header-search-form button').removeClass('focus');
    });
    jQuery('.dropdown-menu', $bedsToggle).on('mouseout', function(event) {
        if (window.innerWidth >= 768) {
            jQuery(this).removeClass('show');
        }
    });
    jQuery('> a', $bedsToggle).on('click', function(event) {
        if (window.innerWidth < 768) {
            event.preventDefault();
            jQuery('.dropdown-menu', $bedsToggle).toggleClass('show');
            $bedsToggle.toggleClass('open');
        }
    });

    // Options for the Intersection Observer
    const options = {
        root: null, // relative to the viewport
        rootMargin: '0px',
        threshold: 0.1 // at least 10% of the video must be visible
    };

    // Callback function to handle intersection changes
    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && ((window.innerWidth >= 768) || !mobileAnimation)) {
                // Video is visible, try to play
                animation.play().catch(error => {
                    // Autoplay was prevented (e.g., sound detected)
                    console.log('Autoplay prevented:', error);
                });
            } else {
                // Video is not visible, pause it
                animation.pause();
            }
        });
    };
    const handleMobileIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && (window.innerWidth < 768)) {
                // Video is visible, try to play
                mobileAnimation.play().catch(error => {
                    // Autoplay was prevented (e.g., sound detected)
                    console.log('Autoplay prevented:', error);
                });
            } else {
                // Video is not visible, pause it
                mobileAnimation.pause();
            }
        });
    };

    // Create the Intersection Observer
    const observer = new IntersectionObserver(handleIntersection, options);
    const mobileObserver = new IntersectionObserver(handleMobileIntersection, options);

    // Start observing the video element
    if (animation) {
        observer.observe(animation);
    }
    if (mobileAnimation) {
        mobileObserver.observe(mobileAnimation);
    }
});
